import { useMutation } from '@apollo/client';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { gql } from '../graphql/generated/gql';
import { UIActions } from '../ui/uiSlice';

const DELETE_POST_MUTATION = gql(/** @complexity 2 */ `
  mutation deletePost($id: ID!) {
    deletePost(id: $id) {
      id
    }
  }
`);

const deletedPostIdsAtom = atom<Record<string, boolean>>({});

export const useIsPostDeletedLocally = (postId: string) => {
  return useAtomValue(deletedPostIdsAtom)[postId] === true;
};

const useDeletePost = () => {
  const dispatch = useAppDispatch();
  const setDeletedPostIds = useSetAtom(deletedPostIdsAtom);
  const [deletePost] = useMutation(DELETE_POST_MUTATION, {
    update(cache, { data }) {
      if (data?.deletePost) {
        cache.evict({ id: cache.identify(data.deletePost) });
      }
    },
  });

  return useCallback(
    async (id: string) => {
      setDeletedPostIds((prev) => ({ ...prev, [id]: true }));
      dispatch(UIActions.removeFromRecentlyViewedPostIds(id));
      await deletePost({ variables: { id } });
    },
    [setDeletedPostIds, dispatch, deletePost],
  );
};

export default useDeletePost;
